
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="confirm-sign-up-section"
  >
  <div class="amplify-form-body" data-test="confirm-sign-up-body-section">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="confirm-sign-up-header-section"
      >
      {{ this.amplifyService.i18n().get('Confirm your sign up code') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get(getUsernameLabel()) }}
        </ion-label>
        <ion-input type="text"
          class="amplify-form-input"
          (input)="setUsername($event.target.value)"
          [value]="username"
          data-test="confirm-sign-up-username-input"
        ></ion-input>
      </ion-item>

      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Code *') }}
        </ion-label>
        <ion-input
          #code
          type="text"
          class="amplify-form-input"
          (input)="setCode(code.value)"
          (keyup.enter)="onConfirm()"
          data-test="confirm-sign-up-confirmation-code-input"
        ></ion-input>
      </ion-item>
    </ion-list>

    <div class="amplify-form-actions">
      <div>
        <ion-button
          expand="block"
          color="primary"
          (click)="onConfirm()"
          data-test="confirm-sign-up-confirm-button"
          >
          {{ this.amplifyService.i18n().get('Confirm Code') }}</ion-button>
      </div>
    <div class="amplify-form-row">
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Have an account?') }}
        <a
          class="amplify-form-link"
          (click)="onSignIn()"
          data-test="confirm-sign-up-back-to-sign-in-link"
          >
          {{ this.amplifyService.i18n().get('Sign In') }}
        </a>
      </div>
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Lost your code?') }}
        <a
          class="amplify-form-link"
          (click)="onResend()"
          data-test="confirm-sign-up-resend-code-link"
          >
          {{ this.amplifyService.i18n().get('Resend') }}
        </a>
      </div>
    </div>
  </div>
</div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
